import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UsersService } from "../../../services/users.service";

declare const $;

@Component({
    selector: 'app-service-side-nav',
    templateUrl: './service-side-nav.component.html',
    styleUrls: ['./service-side-nav.component.css'],
    standalone: false
})
export class ServiceSideNavComponent {
  @Output() onComponentSelected: EventEmitter<any> = new EventEmitter();

  @Input() public selectedTab: string = "service_list";

  public usersService: UsersService;

  constructor(usersService: UsersService) {
    this.usersService = usersService;
  }

  public select(name: string) {
    this.onComponentSelected.emit(name);
    this.selectedTab = name;
  }

  public isSelected(name: string): boolean {
    return this.selectedTab == name;
  }
  public toggleMenu()
  {
    var trigger = $('.js-sidemenu-trigger');
    trigger.toggleClass('is-active');
    var parent = trigger.parents('.js-page');
    parent.toggleClass('menu-opened');
  }
}
